import { getLinkFinalURL } from './get-link-final-url';
import { isStringEmpty } from '../string/is-string-empty.util';
import { AppStateModel } from '../../model/app-state.model';
import { ILink } from '../../interface/page/link.interface';

export function isLinkEmpty(state: AppStateModel, link: ILink, blockMentionData?: any) {
  return isStringEmpty(getLinkFinalURL(state, link, blockMentionData));
}
